import type { PostHogAuthUser, PostHogOrganisation } from "@/lib/posthog/types"

export function isPostHogAuthUser(value: unknown): value is PostHogAuthUser {
  if (!isObjectRecord(value)) {
    return false
  }

  return (
    isStringOrNumber(value.id) &&
    typeof value.email === "string" &&
    (value.firstName === undefined || typeof value.firstName === "string") &&
    (value.lastName === undefined || typeof value.lastName === "string")
  )
}

export function isPostHogOrganisation(value: unknown): value is PostHogOrganisation {
  if (!isObjectRecord(value)) {
    return false
  }

  return (
    isStringOrNumber(value.id) &&
    (value.name === undefined || typeof value.name === "string") &&
    (value.slug === undefined || typeof value.slug === "string") &&
    (value.website === undefined || value.website === null || typeof value.website === "string") &&
    (value.workosOrganizationId === undefined ||
      value.workosOrganizationId === null ||
      typeof value.workosOrganizationId === "string")
  )
}

export function isObjectRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === "object")
}

function isStringOrNumber(value: unknown): value is string | number {
  return typeof value === "string" || typeof value === "number"
}
